/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ contactType: NonNullable<unknown> }} Case_Contact_Type_LabelInputs */

const en_case_contact_type_label = /** @type {(inputs: Case_Contact_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contactType === "claimant_driver") return /** @type {LocalizedString} */ (`Claimant driver`);
	if (i?.contactType === "liable_driver") return /** @type {LocalizedString} */ (`Third-party driver`);
	if (i?.contactType === "insurer") return /** @type {LocalizedString} */ (`Insurance broker`);
	if (i?.contactType === "current_owner") return /** @type {LocalizedString} */ (`Current owner`);
	if (i?.contactType === "owner_at_loss") return /** @type {LocalizedString} */ (`Owner at time of loss`);
	if (i?.contactType === "insured") return /** @type {LocalizedString} */ (`Insured`);
	if (i?.contactType === "debtor") return /** @type {LocalizedString} */ (`Debtor`);
	if (i?.contactType === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.contactType}`)
	
};

const pt_br2_case_contact_type_label = /** @type {(inputs: Case_Contact_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.contactType === "claimant_driver") return /** @type {LocalizedString} */ (`Condutor requerente`);
	if (i?.contactType === "liable_driver") return /** @type {LocalizedString} */ (`Condutor terceiro`);
	if (i?.contactType === "insurer") return /** @type {LocalizedString} */ (`Corretor seguradora`);
	if (i?.contactType === "current_owner") return /** @type {LocalizedString} */ (`Proprietário atual`);
	if (i?.contactType === "owner_at_loss") return /** @type {LocalizedString} */ (`Proprietário na data do sinistro`);
	if (i?.contactType === "insured") return /** @type {LocalizedString} */ (`Segurado`);
	if (i?.contactType === "debtor") return /** @type {LocalizedString} */ (`Devedor`);
	if (i?.contactType === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.contactType}`)
	
};

/**
* | contactType | output |
* | --- | --- |
* | "claimant_driver" | "Claimant driver" |
* | "liable_driver" | "Third-party driver" |
* | "insurer" | "Insurance broker" |
* | "current_owner" | "Current owner" |
* | "owner_at_loss" | "Owner at time of loss" |
* | "insured" | "Insured" |
* | "debtor" | "Debtor" |
* | "other" | "Other" |
* | * | "{contactType}" |
*
* @param {Case_Contact_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_type_label = /** @type {((inputs: Case_Contact_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_type_label(inputs)
	return pt_br2_case_contact_type_label(inputs)
});